import { Injectable } from '@angular/core';
import { EditingItemChoicesService } from './editing-item-choices.service';

@Injectable({
  providedIn: 'root',
})
export class SpecialWizardEditingItemChoicesService extends EditingItemChoicesService {}
